/* tslint:disable */

/**
 */
export class RevenueData {
    sub_total?: number;
    total?: number;
    datetime?: string;
}
